import React from "react";
import "./Catalogue.css";
import Footer from "../../Footer/Footer";

// Assets
import folder from "../../../assets/folder.png";
import catalogimg1 from "../../../assets/catalogimg1.jpg";

// PDF paths (placed in public folder for simplicity)
const pdfLinks = [
  "/assets/pdf/catalogue1.pdf",
];

// Images linked to their respective PDFs
const catalogueImages = [];

const Catalogue = () => {
  return (
    <div>
      {/* Header Section */}
      <div className="catalogue-header">
        <img src={catalogimg1} alt="Catalogue Header" className="header-bg" />
        <div className="catalogue-header-overlay">
          <h1 className="catalogue-heading">Catalogue</h1>
        </div>
      </div>

      {/* Language Section with Folder Click */}
      <div className="catalogue-language-section">
        <div 
          className="language-card"
          onClick={() => {
            if (pdfLinks[0]) {
              window.open(pdfLinks[0], "_blank", "noopener,noreferrer");
            }
          }}
          style={{ cursor: "pointer" }}
        >
          <img src={folder} alt="Catalogue Folder" />
          <p className="folder-name">Catalogue</p>
        </div>
      </div>

      {/* Catalogue Images Grid */}
      <div className="catalogue-grid">
        {catalogueImages.map((img, index) => (
          <div
            key={index}
            className="catalogue-item"
            style={{ cursor: "pointer" }}
          >
            <img src={img} alt={`Catalogue ${index + 1}`} />
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default Catalogue;